import WeatherWidget from '../../components/weather-widget';

const WeatherWidgetPage = () => {
  return <WeatherWidget />;
};

export default WeatherWidgetPage;
